export default class Session {

    isLogged = false;

    constructor(sdk) {
        this.sdk = sdk;
    }

    async getAll() {
        return await this.sdk.fetch().get('/session/all');
    }

    async createOneToOne() {
        return await this.sdk.fetch().post('/onetoone');
    }

    async createOneToOneDemo(patient_email) {
        return await this.sdk.fetch().post('/onetoonedemo/' + patient_email);
    }

    async sendThirdPartyLink(email, onetoone_token, token, hoco_settings) {
        return await this.sdk.fetch().post('/messagethirdpartylink/' + email + '/' + onetoone_token + '/' + token + '/' + hoco_settings);
    }
    
    async destroyOneToOne(token) {
        return await this.sdk.fetch().delete('/onetoone/'+token);
    }

    async get(params) {
        let tokenOneTime = window.localStorage.getItem('token-one-time');
        if (tokenOneTime && tokenOneTime.length > 0)
            this.sdk.fetch().addGlobalHeader('X-Token-Onetime', tokenOneTime);
        this.sdk.fetch().addGlobalHeader('X-User-Session', params.session);
        this.session = await this.sdk.fetch().get('/session/' + params.token + '/' + params.session);

        if (this.session.newsession) {
            document.location.href = '/onetoone/' + params.token + '/' + this.session.newsession.token;
            return;
        }


        if (this.session.token_onetime.length > 0) {
            this.sdk.fetch().removeGlobalHeader('X-Token-Onetime');
            window.localStorage.setItem('token-one-time', this.session.token_onetime);
            this.sdk.fetch().addGlobalHeader('X-Token-Onetime', this.session.token_onetime);
        }

        if (!this.session.validate_fromadmin) {
            this.waitingValidation = true;
            window.sdk.event().emit('waitingAdminValidation');
        }
        else
            this.waitingValidation = false;

        if (this.session.onetoone.status == 'killed') {
            window.sdk.event().emit('killed')
        }

        await window.sdk.connectSocketIO();
        if (this.session.validate_fromadmin) {
            await window.sdk.chat().fetchMessages();
        }
        return this.session;
    }

    onetoone() {
        return this.session.onetoone;
    }

    getToken() {
        return this.session.token;
    }

    getName() {
        return this.session.name;
    }

    isMedecin() {
        return this.session.name == 'medecin';
    }

    isPatient() {
        return this.session.name == 'patient';
    }

    isExtern() {
        return this.session.name == 'extern';
    }

    async me() {
        let me = await this.sdk.fetch().get('/me');
        return me;
    }

    async validate(data) {
        return await this.sdk.fetch().post('/validate', {
            body: data
        });
    }
    async refuse(data) {
        return await this.sdk.fetch().post('/refuse', {
            body: data
        });
    }
    async sendMessage(msg) {
        return await this.sdk.fetch().post('/message', {
            body: { msg }
        });
    }

    async getDocuments() {
        let docs = await this.sdk.fetch().get('/documents'); // look at this
        docs.sort((a,b) =>  new Date(a.date) - new Date(b.date) )
        return docs
    }

    async deleteDocument(doc) {
        return await this.sdk.fetch().delete('/document/' + doc.id);
    }

    async _getDoc2uRoomToken(isPatient, urlParams) {
        let res;
        if (isPatient) {
            //res = await this.sdk.fetch().get('/doc2u-room-token-patient');
            //we send practitien and put local params in iframe
            res = await this.sdk.fetch().get('/doc2u-room-token-practitien' + urlParams);
        }
        else
            res = await this.sdk.fetch().get('/doc2u-room-token-practitien' + urlParams);
        return res;
    }

    async getDoc2uRoomToken(isPatient) {
        let res;
        window.sdk.event().emit('loadingStart');
        let urlParams = '';
        if(window.sdk.getHocoSettings().doc2u)
            urlParams = '?device=' + window.sdk.getHocoSettings().doc2u.device;
        
        res = await this._getDoc2uRoomToken(isPatient, urlParams);
        
        console.log('doc2u res', res)

        if(res.error || res == 'failed') {
            console.log('doc2u error', res.error, 'we try an other time');
            await window.sdk.sleep(1000);
            res = await this._getDoc2uRoomToken(isPatient, urlParams);            
        }

        if(res.error) {
            console.log('this is the end, we can not get doc2u token');
            console.log('put an alert here ? and a sentry log ?');
        }

        window.sdk.event().emit('loadingStop');
        return res;
    }

    async downloadDocuments(docs) {
        let ids = docs.map(doc => doc.id)
        let response = await this.sdk.fetch().post('/documents/download', {
            body: { ids },
            contentType: 'application/json'
            //contentType: 'application/octet-stream'
        });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    async sendLog() {
        return await this.sdk.fetch().get('/session/log');
    }

    getFileIcon(file) {
        let icon = "icon-file-link";
        switch(file.type) {
            case 'application/pdf':
                icon = "icon-file-pdf";
                break;
            case 'image/jpeg':
            case 'image/jpg':
            case 'image/png':
            case 'image/bmp':
            case 'image/gif':
                icon = "icon-file-camera";
                break;
            case 'audio/mp3':
                icon = "icon-file-audio";
                break;
            case 'text/txt':
                icon = "icon-file-doc";
                break;
            case 'video/webm':
            case 'video/mp4':
            case 'video/webm':
                icon = "icon-file-video";
                break;
        }
        return icon;
    }


    async getMedicalInfo(){
        console.log('getMedicalInfo',this.isPatient());
        if(this.isPatient()){
            return this.session.onetoone && this.session.onetoone.medical_info ? this.session.onetoone.medical_info.data : {};
            
        }
        return await this.sdk.fetch().get('/session/infos');
    }

    async saveMedicalInfo(data){       
        let res = await this.sdk.fetch().post('/session/infos', {
            body: {data}
        });

        if (!this.session.onetoone.medical_info) 
        this.session.onetoone.medical_info = {};
        
        if (!this.session.onetoone.medical_info.data ) 
            this.session.onetoone.medical_info.data = {};

        if (res.data && res.data) 
            Object.assign(this.session.onetoone.medical_info.data, res.data);
    }

    async previewCR() {
        return await this.sdk.fetch().get('/report-pdf');
    }

    async downloadCR() {
        return await this.sdk.fetch().get('/generate-pdf', {
            contentType: 'application/pdf'
        });
    }
}